import { getHttpClient } from '../../api/axiosInstance'
import { useQuery } from '@tanstack/react-query'

const loadCacheClient = async () => {
  const apiClient = getHttpClient()

  const response = await apiClient.get('/cache/v1/clients')

  return response.data
}

export const key = 'cache.client'

export const useCacheClient = () => {
  return useQuery({
    queryKey: [key],
    queryFn: loadCacheClient,
    refetchOnWindowFocus: false,
    staleTime: 60 * (60 * 1000), // 60 minutes
    cacheTime: 60 * (60 * 1000) // 60 minutes
  })
}

/**
 * Selectors for RAW data
 */
const getClients = (data) => (data?.clients || [])
const getProjects = (data) => (data?.projects || [])
const getPointsOfSale = (data) => (data?.points_of_sale || [])
const getComponents = (data) => (data?.components || [])

/**
 * Generic function to create an array indexed by id
 *
 * TODO:
 *    - Should be a function ? ( errores when ids outside of its domain )
 *    - Should be in the reducer ?
 */
const getById = (list) => {
  return list.reduce((acc, cur) => ({ ...acc, [cur.id]: cur }), {})
}

/**
 * Selectors for display data for a specific ID
 */
export const getClientsById = (state) => getById(getClients(state))
export const getProjectsById = (state) => getById(getProjects(state))
export const getPointsOfSaleById = (state) => getById(getPointsOfSale(state))
export const getComponentsById = (state) => getById(getComponents(state))

export const getClientsForSelect = (state) => {
  const list = getClients(state).filter((item) => item.active)
  return (list || []).map((item) => {
    return { ...item, value: item.id, label: item.name, active: item.active.toString() }
  })
}

export const getProjectsForSelect = (state) => {
  const list = getProjects(state).filter((item) => item.active)
  return (list || []).map((item) => {
    return { ...item, value: item.id, label: item.name, active: item.active.toString() }
  })
}

export const getProjectsWithOptForSelect = (state) => {
  const projects = getProjectsForSelect(state)
  return getClientsForSelect(state).map((item) => {
    const { value, ...rest } = item

    const options = projects
      .filter((item) => item.active && item.client_fk && item.client_fk.id == value)
      .map((item) => {
        return { ...item, value: item.id, label: item.name, active: item.active.toString() }
      })

    return { ...rest, options }
  })
};

export const getPointsOfSaleForSelect = (state) => {
  const list = getPointsOfSale(state).filter((item) => item.active)
  return (list || []).map((item) => {
    return { ...item, value: item.id, label: item.name, active: item.active.toString() }
  })
}

export const getPointsOfSaleWithOptForSelect = (state) => {
  const clients = getClients(state).filter((item) => item.active)
  const pointsOfSale = getPointsOfSaleForSelect(state)

  return getProjectsForSelect(state)
    .map((item) => {
      const { value, client_fk, ...rest } = item

      const client = clients.find((item) => item.id === client_fk?.id)
      const label = client && client.name ? `${client.name} > ${item.label}` : `${item.label}`

      const options = pointsOfSale
        .filter((item) => item.active && item.project_fk && item.project_fk.id == value)
        .map((item) => {
          return { ...item, value: item.id, label: item.name, active: item.active.toString() }
        })

      return { ...rest, options, label }
    })
    .filter((item) => (item.options || []).length > 0)
}

export const getPointOfSalesByProjectForSelect = (state) => (projectId) => {
  const list = getPointsOfSale(state).filter((item) => item.project_fk.id == projectId);

  return (list || []).map((item) => {
    return { value: item.id, label: item.name + " (" + item.code + ")" };
  })
}


export const getComponentsForSelect = (state) => {
  const list = getComponents(state).filter((item) => item.active)
  return (list || []).map((item) => {
    return { ...item, value: item.id, label: item.name, active: item.active.toString() }
  })
}

export const getComponentByPointOfSaleForSelect = (state) => (posId) => {
  const pos = getPointsOfSale(state).find(item => item.id == posId)

  if (pos) {
    return (pos.components || []).map((item) => {
      return { value: item.id, label: item.name }
    })
  }

  return []
  // const list = getComponents(state).filter((item) => item.pointOfSale == posId)

  // return (list || []).map((item) => {
  //  return { value: item.id, label: item.name }
  //})
}

